import { useNavigate, createSearchParams } from 'react-router-dom';
import React, { useRef, useState, useEffect } from 'react';
import Keyboard from 'react-simple-keyboard';

import { showNotification } from '@mantine/notifications';

import OTPInput from 'otp-input-react';
import { useTranslation } from 'react-i18next';
import 'react-simple-keyboard/build/css/index.css';

import {
  Box,
  Center,
  Stack,
  Title,
  Modal,
  Text,
  Group,
  Image,
  Container,
  Loader,
  ActionIcon,
} from '@mantine/core';
import { IconX } from '@tabler/icons';

import { Check } from 'tabler-icons-react';
import AlertImg from '../../image/alert.svg';
import PrimaryButton from '../../components/GroupButton';
import { sendRequest, sendRequestWithToken } from '../../services/services';
import PaymentStatus from '../PosPayment/PaymentStatus';
import TicketSummary from '../../components/TicketSummary/TicketSummary';

const UserDetails = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const [, setMounted] = useState(false);
  const [, setLocation] = useState('');
  const [shiftButtonText, setShiftButtonText] = useState('Arabic');

  const [cardPay, setCardPay] = useState(false);
  const [errorPos, setErrorPos] = useState(false);
  const siteDetails = JSON.parse(localStorage.getItem('siteDetails'));

  useEffect(() => {
    setMounted(true);
    setLocation(`${window.location.protocol}//${window.location.host}/`);
  }, []);

  const [, setTicketNumber] = useState();

  const [ticketData, setTicketData] = useState();
  const [input] = useState('');
  const [layout, setLayout] = useState('default');
  const keyboard = useRef();

  const [, setCharInput] = useState('');
  const [dummyInput] = useState('');
  const [dummycharInput, setDummyCharInput] = useState('');

  const [validPassId, setValidPassId] = useState();

  const searchTicket = () => {
    sendRequest(`tickets/${dummyInput + dummycharInput}`, 'get')
      .then((res) => {
        if (res?.code === 20) {
          setTicketData(res?.data || []);
        }
      })
      .catch((err) => {
        if (err?.response?.data?.code) {
          showNotification({
            title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
            icon: <IconX size={16} />,
          });
        }
      });

    setTicketNumber(input);
  };

  useEffect(() => {
    if (ticketData?.pass_id) {
      sendRequest(`parking/site-id-by-pass-id/${ticketData?.pass_id}`, 'get').then((res) => {
        if (res?.data?.site_id === siteDetails?.siteId) {
          setValidPassId(ticketData || []);
        } else if (res?.data?.site_id !== siteDetails?.siteId) {
          showNotification({
            title: <Text weight={500}>{t('enter.invalid.site.id')}</Text>,
            icon: <IconX size={16} />,
          });
        }
      });
    }
  }, [ticketData]);

  const onCharChange = (charInput) => {
    setDummyCharInput(charInput);
  };

  const handleShift = () => {
    const newLayoutName = layout === 'default' ? 'shift' : 'default';
    setLayout(newLayoutName);
    if (shiftButtonText === 'Arabic') {
      setShiftButtonText('English');
    } else if (shiftButtonText === 'English') {
      setShiftButtonText('Arabic');
    }
  };

  const onKeyPress = (button) => {
    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === '{shift}' || button === '{lock}') handleShift();
    if (button === '{enter}') searchTicket();
  };

  const onChangeCharInput = (event) => {
    const data = event.target.value;
    setCharInput(data);
    keyboard.current.setCharInput(data);
  };

  useEffect((button) => {
    if (button === '{enter}') {
      searchTicket();
    }
  }, []);

  const [response] = useState('');
  const [paymentStatus, setPaymentStatus] = useState('');
  const [, setCashData] = useState();

  useEffect(() => {
    if (response?.TerminalAction === 'SWIPE_OR_INSERT') {
      setCardPay(true);
    } else if (response?.TerminalAction === 'IDLE_SCREEN') {
      setCardPay(false);
    } else if (response?.EventName === 'TERMINAL_RESPONSE') {
      setPaymentStatus(JSON.parse(response?.JsonResult));
    } else if (response?.TerminalStatus === 'BUSY') {
      setCardPay(true);
    }
  }, []);

  useEffect(() => {
    if (response?.EventName === 'TERMINAL_RESPONSE') {
      const body = {
        reservation_id: parseInt(ticketData?.result?.id, 10),
        transaction_id: paymentStatus?.RetrievalReferenceNumber,
      };
      sendRequestWithToken(`cashier/card-payment`, 'post', body)
        .then(({ data, code }) => {
          if (code === 20) {
            setCashData(data);
            searchTicket();
            setCardPay(false);
            navigate({
              pathname: '/qrScanner',
              search: createSearchParams({
                passId: ticketData?.pass_id,
              }).toString(),
            });
          }
        })
        .catch((err) => {
          if (err?.response?.data?.code) {
            // console.log('err', err?.response?.data?.code);
          }
        });
    }
  }, [
    paymentStatus,
    paymentStatus?.RetrievalReferenceNumber,
    response?.EventName,
    searchTicket,
    ticketData?.result?.id,
  ]);

  return (
    <>
      <Modal opened={cardPay} onClose={() => setCardPay(false)} centered size="90%">
        <Center>
          {paymentStatus?.TransactionResponseEnglish === 'APPROVED' ||
          ticketData?.invoices?.invoice_status?.name === 'paid' ? (
            <PaymentStatus
              invoiceDataId={ticketData?.invoices?.id}
              passDataId={ticketData?.passId}
            />
          ) : (
            <Center>
              {response?.TerminalAction === 'SWIPE_OR_INSERT' ? (
                <Stack>
                  <Title order={1}>Swipe or Insert</Title>
                  <Center>
                    <Title order={1}>Card</Title>
                  </Center>
                </Stack>
              ) : (
                <div>
                  {response?.TerminalAction === 'USER_CANCELLED_AND_TIMEOUT' ? (
                    <Stack>
                      <Title order={1}>Cancel or Timeout</Title>
                    </Stack>
                  ) : (
                    <div>
                      {response?.TerminalStatus === 'BUSY' && (
                        <Stack>
                          <Title order={1}>Payment Processing</Title>
                          <Loader variant="dots" />
                        </Stack>
                      )}

                      {paymentStatus?.TransactionResponseEnglish === 'DECLINED' && (
                        <Stack>
                          <Title order={1}>Card Declined</Title>
                        </Stack>
                      )}
                    </div>
                  )}
                </div>
              )}
            </Center>
          )}
        </Center>
      </Modal>
      <Modal opened={errorPos} onClose={() => setErrorPos(false)} centered size="50%">
        <Center>
          <Image src={AlertImg} width={100} />;
        </Center>
        <Center py="xl">
          <Title order={1}>Error with Connection</Title>
        </Center>
      </Modal>
      <Box style={{ height: 'calc(100vh - 24px)', marginTop: '24px' }}>
        <Stack justify="space-between" style={{ height: '100%' }}>
          <Box>
            <Container
              className="home"
              style={{
                display: 'flex',
                alignItems: 'stretch',
                flexDirection: 'column',
              }}
            >
              <PrimaryButton />
            </Container>
          </Box>

          {!validPassId?.pass_id ? (
            <>
              <Box>
                <Container
                  className="home"
                  style={{
                    display: 'flex',
                    alignItems: 'stretch',
                    flexDirection: 'column',
                  }}
                >
                  <Stack>
                    <Title style={{ color: '#2C5864', margin: '2% 0' }} order={3}>
                      {t('enter.car.numberplate')}
                    </Title>
                  </Stack>
                  <Stack style={{ color: '#2C5864', marginBottom: '0%' }}>
                    <Center>
                      <Group>
                        <OTPInput
                          OTPLength={7}
                          inputStyles={{
                            width: '60px',
                            height: '50px',
                            fontSize: '2.5rem',
                          }}
                          value={dummycharInput}
                          onChange={onChangeCharInput}
                          disabled={ticketData?.id}
                        />
                        <ActionIcon
                          onClick={() => searchTicket()}
                          color="teal"
                          size="xl"
                          radius="md"
                          variant="filled"
                          style={{ backgroundColor: '#50A847', width: '50px', height: '50px' }}
                        >
                          <Check size={44} />
                        </ActionIcon>
                      </Group>
                    </Center>
                  </Stack>
                </Container>
              </Box>
              <Box py="sm" style={{ direction: 'ltr', backgroundColor: '#22444E' }}>
                <Container>
                  <Keyboard
                    keyboardRef={(r) => {
                      keyboard.current = r;
                    }}
                    onChange={onCharChange}
                    onKeyPress={onKeyPress}
                    layoutName={layout}
                    maxLength={7}
                    theme="hg-theme-default hg-layout-default myTheme"
                    layout={{
                      theme: 'hg-theme-default',
                      default: [
                        '1 2 3 4 5 6 7 8 9 0 {bksp}',
                        'Q W E R T Y U I O P',
                        'A S D F G H J K L',
                        '{shift} Z X C V B N M',
                        '{space}',
                      ],
                      shift: [
                        '\u0630 \u0661 \u0662 \u0663 \u0664 \u0665 \u0666 \u0667 \u0668 \u0669 \u0660 {bksp}',
                        '\u0636 \u0635 \u062B \u0642 \u0641 \u063A \u0639 \u0647 \u062E \u062D \u062C \u062F',
                        '\u0634 \u0633 \u064A \u0628 \u0644 \u0627 \u062A \u0646 \u0645 \u0643 \u0637',
                        '{shift} \u0626 \u0621 \u0624 \u0631 \u0644\u0627 \u0649 \u0629 \u0648 \u0632 \u0638',
                        '{space}',
                      ],
                    }}
                    buttonTheme={[
                      {
                        class: 'active',
                        buttons:
                          dummycharInput.length < 0
                            ? null
                            : '1 2 3 4 5 6 7 8 9 0 A B J D R S X T E G K L Z N H U V',
                      },
                      {
                        class: 'active',
                        buttons:
                          dummycharInput.length < 0
                            ? null
                            : '\u0661 \u0662 \u0663 \u0664 \u0665 \u0666 \u0667 \u0668 \u0669 \u0660 ا ب ح د ر س ص ط ع ق ك ل م ن ه و ى',
                      },
                    ]}
                    display={{
                      '{bksp}': '←',
                      '{space}': ' ',
                      '{enter}': shiftButtonText !== 'Arabic' ? 'إرسال' : 'Enter',
                      '{shift}': shiftButtonText !== 'Arabic' ? '&#127760;' : '&#127760;',
                    }}
                  />
                </Container>
              </Box>
            </>
          ) : null}

          {validPassId?.pass_id ? (
            <Box style={{ flexGrow: '1' }}>
              <Container
                className="home"
                style={{
                  display: 'flex',
                  alignItems: 'stretch',
                  flexDirection: 'column',
                  height: '100%',
                }}
              >
                <TicketSummary passId={ticketData?.pass_id} />
              </Container>
            </Box>
          ) : null}
        </Stack>
      </Box>
    </>
  );
};

export default UserDetails;
